module.exports = __webpack_public_path__ + "media/recipes/39-eaa97bc1.png";